module.exports = "<span *ngIf=\"errorMessage !== null\">{{errorMessage}}</span>"